module.exports = __webpack_public_path__ + "img/70.dbe68de9.jpg";